import { HomeRouteName } from '@/types/router/name/home';
import { HomeRoutePath } from '@/types/router/path/home';
import DashboardLayout from '@/layouts/DashboardLayout.vue';
import auth from '@/middleware/auth';
import type { Middleware } from '@/types/router';

export default [
    {
        path: HomeRoutePath.Home,
        name: HomeRouteName.Home,
        component: () => import('@/pages/index.vue'),
        meta: {
            group: 'home',
            title: 'Home',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    }
];
